import { message } from "antd";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { postCharge } from "../../../helpers/api";
import _ from "lodash";
import { RequiredIndicator } from "../../../components";
import smallTalk from "smalltalk";
import { CHARGE_VALUE_TYPES } from "../../../helpers/config";
import { getUser } from "../../../helpers/auth";

export default function NewChargeForm({ onSuccess }) {
  const { handleSubmit, register, reset, watch } = useForm();

  const { mutateAsync, isLoading } = useMutation(
    (data) => postCharge(getUser().facility.id, data),
    {
      onSuccess: (data, variables, context) => {
        if (data.status === 201) {
          message.success("Done!");
          reset();
          onSuccess();
          return;
        }

        throw data;
      },
      onError: (error, variables, context) => {
        const err = error.response?.data?.message;
        if (_.isArray(err)) {
          err.map((err) => message.error(err.message));
        } else {
          message.error(err || "Error creating charge");
        }
      },
      retry: true,
    }
  );

  const postSubmit = (data) => {
    smallTalk
      .confirm("Add Charge", "You are about to add a charge. Continue?", {
        buttons: {
          ok: "YES",
          cancel: "NO",
        },
      })
      .then(() => mutateAsync(data))
      .catch((ex) => message.error("no action taken"));
  };

  const valueType = watch("valueType");

  return (
    <form onSubmit={handleSubmit(postSubmit)}>
      <div className="field">
        <label htmlFor="title">
          Title
          <RequiredIndicator />
        </label>
        <input
          type="text"
          id="title"
          autoFocus
          {...register("title", { required: true })}
          className="input w-100"
          placeholder="Enter charge title"
        />
      </div>

      <div className="field">
        <label htmlFor="valueType">
          Value Type
          <RequiredIndicator />
        </label>
        <select
          id="valueType"
          {...register("valueType", { required: true })}
          className="input w-100">
          <option value="">Select value type</option>
          {CHARGE_VALUE_TYPES.map((type) => (
            <option key={type.value} value={type.value}>
              {type.label}
            </option>
          ))}
        </select>
      </div>

      <div className="field">
        <label htmlFor="value">
          {valueType === "percentage" ? "Percentage (%)" : "Amount"}
          <RequiredIndicator />
        </label>
        <input
          type="number"
          id="value"
          step={valueType === "percentage" ? "0.01" : "0.01"}
          min={0}
          max={valueType === "percentage" ? 100 : undefined}
          {...register("value", {
            required: true,
            min: 0,
            max: valueType === "percentage" ? 100 : undefined,
          })}
          className="input w-100"
          placeholder={
            valueType === "percentage"
              ? "Enter percentage (0-100)"
              : "Enter amount"
          }
        />
        {valueType === "percentage" && (
          <small>Enter a value between 0 and 100</small>
        )}
      </div>

      <div className="field">
        <label htmlFor="description">Description</label>
        <textarea
          id="description"
          {...register("description")}
          className="textarea w-100"
          rows={4}
          placeholder="Enter charge description"></textarea>
      </div>

      <div className="field mt-4">
        <button
          type="submit"
          className="button app-btn btn-prim w-100 p-2"
          disabled={isLoading}>
          {isLoading ? "Creating..." : "Add Charge"}
        </button>
      </div>
    </form>
  );
}
